/****************************************************
 * Module Name:  labProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class LabProxy {
  static GetAllLab = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lab",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllLabMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lab/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleLab = (labId, callback) => {
    let params = {
      id: labId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/lab",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckLabAvailable = (lab, callback) => {
    let params = {
      lab: lab,
    };

    restAPICall(
      Constants.MANAGER_URL + "/lab/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddLab = (lab, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lab",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(lab),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateLab = (lab, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lab",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(lab),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteLab = (lab, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lab",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(lab),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
